var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level-left"},[(_vm.task_type == 'srt')?_c('div',[_c('p',[_vm._v("Salvo por último as: "+_vm._s(_vm._f("toDate")(_vm.last_saved_date_srt)))])]):_c('div',[_c('p',[_vm._v("Salvo por último as: "+_vm._s(_vm._f("toDate")(_vm.last_saved_date_txt)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }